import {EOperationType} from '../model/dwh-data-preparation-modal.types';

export const CONTEXT_URL = '/expo-dwh-integration/api/';
export const API_URL = {
    [EOperationType.Protocol]: 'request-dwh-transactions-protocol',
    [EOperationType.Registry]: 'request-dwh-doc-journal',
    [EOperationType.Enrichment]: 'request-dwh-enrichment-register-document-data',
};

